module.exports = __webpack_public_path__ + "img/society-davinci-avatar.0c453923.png";